module.exports = __webpack_public_path__ + "media/images/solutions-analytics-triplet-2-3c8019460434465a12944a2c31d404b8.svg";